import Vue from 'vue'
import { GLANCODE_INIT_LOADING, GLANCODE_INIT_SUCCESS, GLANCODE_INIT_FAIL, GLANCODE_COMMIT_KEY } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  glAnCode: {
    glAcctNoId: {
      glAnCode: null,
      name: null,
      description: null
    },
    updateCnt: 0
  }
}

const getters = {

}

const actions = {
  async glAnCodeManagementInit({ commit, dispatch, rootState }) {
    const apiUrl = rootState.app.menu.glAnCodeManagement
    commit(GLANCODE_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(GLANCODE_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(GLANCODE_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

const mutations = {
  [GLANCODE_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [GLANCODE_INIT_SUCCESS](state, data) {
    state.init = 1
    Vue.set(state, 'menu', data.menu)
    state.initErr = []
  },
  [GLANCODE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [GLANCODE_COMMIT_KEY](state, data) {
    const commit = {
      glAnCode: data.glAnCode,
      glAnType: data.glAnType,
      glAnDesc: data.glAnDesc
    }
    sessionStorage.setItem('glAnCode', JSON.stringify(commit))
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
